export default {
  h1: {
    color: 'var(--color-text)',
    fontWeight: 700,
    fontSize: '2.25rem',
    lineHeight: 1.2,
  },

  h2: {
    color: 'var(--color-text)',
    fontWeight: 700,
    fontSize: '1.875rem',
    lineHeight: 1.25,
  },

  h3: {
    color: 'var(--color-text)',
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: 1.3,
  },

  h4: {
    color: 'var(--color-text)',
    fontWeight: 600,
    fontSize: '1.25rem',
  },

  h5: {
    color: 'var(--color-text)',
    fontWeight: 600,
    fontSize: '1.125rem',
  },

  h6: {
    color: 'var(--color-text)',
    fontWeight: 500,
    fontSize: '1rem',
  },

  body1: {
    color: 'var(--color-text)',
    fontSize: '0.95rem',
    lineHeight: 1.6,
  },

  body2: {
    color: 'var(--color-text-secondary)',
    fontSize: '0.875rem',
    lineHeight: 1.55,
  },

  subtitle1: {
    color: 'var(--color-text-secondary)',
    fontSize: '0.875rem',
    fontWeight: 500,
  },

  subtitle2: {
    color: 'var(--color-text-muted)',
    fontSize: '0.8125rem',
    fontWeight: 500,
  },

  caption: {
    color: 'var(--color-text-muted)',
    fontSize: '0.75rem',
  },

  overline: {
    color: 'var(--color-text-muted)',
    fontSize: '0.7rem',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },

  button: {
    color: 'var(--color-text)',
    fontWeight: 600,
    textTransform: 'none',
  },

  pxToRem: (size) => `${size / 16}rem`,
};
